import { type MovementTuning, TUNING_DEFAULTS } from '../movement/tuning';
import type { CharacterDef } from './types';

/**
 * Resolve a hero's sparse feel delta into a complete MovementTuning by layering
 * it over TUNING_DEFAULTS. A hero with an empty delta resolves bit-for-bit to
 * the base game's feel — that invariant is locked by resolveTuning.test.ts.
 */
export function resolveCharacterTuning(def: CharacterDef): MovementTuning {
  return { ...TUNING_DEFAULTS, ...def.tuning };
}
